
export default {
  watch: {
    '$route' ():void {
      const navcollapse = document.querySelector('#mainNavbarToggle');
      if (navcollapse && navcollapse.classList.contains('show')) {
        navcollapse.classList.remove('show');
      }
    }
  }
}
